import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fullscreen",
  "use": "icon-fullscreen-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fullscreen\"><path d=\"M213.333 341.333V213.333h128V128H128v213.333h85.333zM341.333 810.667v-85.334H213.333v-128H128v213.334h213.333zM810.667 341.333h85.333V128H682.667v85.333h128v128zM896 597.333h-85.333v128h-128v85.334H896v-213.334z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fullscreen.svg
// module id = WIff
// module chunks = 72